import clsx from 'clsx';

const variants = {
  success: 'bg-[#DCFCE7] text-[#15803D]',
  warning: 'bg-[#FEF3C7] text-[#92400E]',
  danger: 'bg-[#FEE2E2] text-[#B91C1C]',
  info: 'bg-[#CFFAFE] text-[#0E7490]',
  muted: 'bg-[#F3F4F6] text-[#4B5563]',
  orange: 'bg-orange-soft text-orange-deep'
};

export function Pill({ variant = 'muted', children, className = '' }) {
  return <span className={clsx('pill', variants[variant] || variants.muted, className)}>{children}</span>;
}
